var path = '/glow/component/glow-module/module-embed/tpl/module-embed.html';
var html = "<div class=glow-embed ng-class=$ctrl.classes.wrapper ng-style=$ctrl.styles.wrapper> <div ng-class=\"{ 'text-center': !$ctrl.isRich }\" ng-if=$ctrl.isHtml dynamic-bind-html={{::$ctrl.html}}></div> <iframe class=embed-responsive-item scrolling={{::$ctrl.scrolling}} ng-if=$ctrl.isUrl ng-src={{$ctrl.trustSrc($ctrl.iframeUrl)}}></iframe> {{$ctrl.renderCallback()}} </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-module/module-embed/tpl/module-embed.html
// module id = 1725
// module chunks = 1